<template>
  <div class="container">
    <img src="static/img/homepagetop.png" alt="" />
    <div class="top">
      <img v-if="member.img" :src="member.img" class="tx" alt="" />
      <img
        v-else
        src="//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
        class="tx"
        alt=""
      />

      <div
        class="bt"
        v-show="my_id != $route.query.id"
        @click="follow($route.query.id)"
        :class="{ ygz: isfollow }"
      >
        <div v-show="my_id != $route.query.id && !isfollow">关注</div>
        <div v-show="my_id != $route.query.id && isfollow">已关注</div>
      </div>
      <div
        class="bt"
        @click="edit"
        style="background: #e8ecf9; border: none"
        v-show="my_id == $route.query.id"
      >
        <p v-if="!editable" style="color: #1646c0">编辑简介</p>
        <p v-else style="color: #1646c0">完成</p>
      </div>
    </div>
    <div>
      <div style="padding: 16px" class="detail">
        <p class="name">{{ member.name }}</p>
        <div class="flex">
          <p>
            <span>{{ count }}</span
            >发布
          </p>
          <p>
            <span>{{ member.follow_count }}</span
            >粉丝
          </p>
        </div>
      </div>
      <van-cell-group v-show="editable">
        <van-field
          v-model="message"
          rows="2"
          autosize
          label="简介"
          type="textarea"
          placeholder="请输入简介"
          maxlength="20"
          show-word-limit
        />
      </van-cell-group>
      <!-- <van-collapse v-model="activeNames">
        <van-collapse-item title="简介" name="1">{{member.intro}}</van-collapse-item>
      </van-collapse> -->
      <div
        v-show="!editable"
        style="padding: 20px; padding-top: 0; font-size: 14px"
      >
        <table></table>
        <p>简介：</p>
        <p
          style="
            text-indent: 2em;
            margin-top: 10px;
            line-height: 2em;
            font-weight: 500;
            color: slategrey;
          "
        >
          {{ member.intro }}
        </p>
      </div>
    </div>
    <div class="maindiv">
      <table></table>
      <div class="tabs">
        <div :class="{ active: tab == 0 }">
          <p
            @click="
              tab = 0;
              inithomepage();
            "
          >
            发布活动列表
          </p>
          <div class="tabhr" v-show="tab == 0"></div>
        </div>
        <div :class="{ active: tab == 1 }">
          <p
            @click="
              tab = 1;
              initorglist();
            "
          >
            所属组织介绍
          </p>
          <div class="tabhr" v-show="tab == 1"></div>
        </div>
      </div>
      <div class="tabcontainer" style="background: #f0f2f5" v-show="tab == 0">
        <table></table>
        <van-list
          v-model="listloading"
          :finished="listfinished"
          :immediate-check="false"
          finished-text="没有更多啦"
          @load="listload_more()"
        >
          <div
            v-for="(item, index) in list"
            :key="item.id"
            class="main"
            v-show="
              (item.state == 2 && my_id != $route.query.id) ||
              my_id == $route.query.id
            "
          >
            <div class="maintop" style="margin: 10px 0">
              <img v-if="item.headimg" :src="item.headimg" alt="" />
              <img
                v-else
                src="//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
                alt=""
              />
              <div>
                <p>
                  {{ item.member_name
                  }}<span class="level">({{ item.level_str }})</span>
                </p>
                <!-- <p class="level" style="color: red">{{ item.org_name }}</p> -->
                <p class="date">{{ timeTrans(item.createtime) }}</p>
              </div>
            </div>
            <div>
              <div class="pics" v-show="item.imgs.length > 0">
                <!-- <img
                  :src="value"
                  v-for="(value, index) in item.imgs"
                  :key="index"
                  alt=""
                  @click="preview(item.imgs, index)"
                /> -->
                <van-swipe
                  class="my-swipe"
                  indicator-color="white"
                  v-if="item.imgs.length > 0"
                >
                  <van-swipe-item
                    v-for="(value, index) in item.imgs"
                    :key="index"
                  >
                    <img
                      v-lazy="value"
                      alt=""
                      @click="preview(item.imgs, index)"
                    />
                  </van-swipe-item>
                </van-swipe>
              </div>
              <!-- new video zoom -->
              <div class="video" v-show="item.video">
                <video
                  :src="item.video"
                  controls
                  preload
                  style="
                    width: 100%;
                    height: 56vw;
                    object-fit: cover;
                    background: black;
                  "
                ></video>
              </div>
              <p class="content">
                {{ item.content
                }}<span @click="totopic(item.task_id)"
                  >#{{ item.task_title }}#</span
                >
              </p>
              <!-- <p class="tag" @click="totopic(item.task_id)">
                来自活动<span>#{{ item.task_title }}#</span>
              </p> -->
              <!-- 评论区，最多显示5个 -->
              <div class="commentzoom" v-if="item.state == 2">
                <div
                  v-for="(item2, index2) in item.comments"
                  :key="item2.id"
                  style="margin: 5px auto"
                >
                  <div
                    class="flexcomment"
                    v-show="
                      index2 < item.showcomment + (item.commentnum - 1) * 10
                    "
                  >
                    <p
                      style="
                        font-size: 14px;
                        color: #333;
                        font-weight: 600;
                        white-space: nowrap;
                      "
                      @click="tohomepage(item2.m_id)"
                    >
                      {{ item2.m_name }}：
                    </p>
                    <div>
                      <p style="font-size: 14px; color: #666">
                        {{ item2.content }}
                      </p>
                    </div>
                  </div>
                </div>
                <van-divider
                  :style="{ color: '#1989fa', padding: '0 16px' }"
                  v-if="
                    item.comments.length >
                    item.showcomment + (item.commentnum - 1) * 10
                  "
                  @click="showmorecomment(list, index)"
                >
                  查看剩余评论
                </van-divider>
              </div>
              <!-- 完毕 -->
              <div class="flex" style="margin: 10px 0" v-if="item.state == 2">
                <!-- 已过审显示评论区以及评论功能 -->
                <!-- <img :src="tx" v-if="tx" class="txsmall" alt="" />
                <img
                  src="http://pic-cdn.bigdatajy.com/wenming/static/img/icon3.png"
                  v-else
                  class="txsmall"
                  alt=""
                /> -->
                <el-input
                  type="textarea"
                  readonly
                  placeholder="随时回应"
                  v-model="item.pinglun"
                  autosize
                  @click.native="choosepinglun(list, index)"
                ></el-input>
                <van-icon
                  style="margin-left: 10px; margin-top: 5px"
                  name="comment-o"
                  size="24"
                  @click="
                    item.pinglun && send(item.id, item.pinglun, list, index)
                  "
                />
              </div>
              <hr v-if="item.state != 2" />
              <p
                class="state"
                v-if="item.state == 1 && my_id == $route.query.id"
              >
                审核中
              </p>
              <p
                class="state"
                v-if="item.state == 3 && my_id == $route.query.id"
              >
                驳回
              </p>
              <table></table>
              <div class="flexicon" v-if="item.state == 2">
                <div
                  @click="
                    share(item.task_id, item.task_title, index, list, item.id)
                  "
                >
                  <!-- <van-icon name="share-o" size="14" />
                  <span>{{ item.zhuanfa }}</span> -->
                  <img src="static/img/share.png" alt="" />
                  <p>转发</p>
                </div>
                <!-- zhuanfa(item.id,index,list) -->
                <div
                  @click="shoucang(item.id, index, list)"
                  style="margin-left: auto; margin-right: 15px"
                >
                  <van-icon name="star-o" size="16" v-show="!item.isfav" />
                  <van-icon
                    name="star"
                    size="16"
                    color="#1646C0"
                    v-show="item.isfav"
                  />
                  <!-- <span>{{ item.fav }}</span> -->
                  <p>收藏</p>
                </div>
                <div @click="dianzan(item.id, index, list)">
                  <van-icon name="like-o" size="16" v-show="!item.iszan" />
                  <van-icon
                    name="like"
                    size="16"
                    color="#1646C0"
                    v-show="item.iszan"
                  />
                  <!-- <span>{{ item.zan }}</span> -->
                  <p>赞</p>
                </div>
                <!-- <div @click="share(item.task_id,item.task_title,index,list)">
                <van-icon name="expand-o" size="14"/>
                <span>分享</span>
              </div> -->
              </div>
            </div>
          </div>
        </van-list>
      </div>
      <div class="tabcontainer" v-show="tab == 1" style="background: #f8f8f8">
        <van-list
          v-model="listorgloading"
          :finished="listorgfinished"
          :immediate-check="false"
          finished-text="没有更多啦"
          @load="listorgload_more()"
        >
          <div
            class="mainorg"
            v-for="item in listorg"
            :key="item.index"
            @click="urlchange(item.id)"
          >
            <img :src="item.img" alt="" />
            <div class="right">
              <p class="name">{{ item.name }}</p>
              <p class="info" v-html="item.intro"></p>
              <p class="location">{{ item.address }}</p>
              <div class="flex" style="color: #999">
                <div>
                  <i class="el-icon-user"></i>
                  <span>{{ item.count }}人</span>
                </div>
                <div>
                  <p>创建于{{ item.create_date }}</p>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <!-- new -->
    <van-popup
      v-model="show"
      round
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="comments">
        <p @click="choose()">志愿者最光荣，你们是江阴美丽的风景线。</p>
        <p @click="choose()">这次活动我有事没参加，下次活动请带带我。</p>
        <p @click="choose()">你们真是太棒了，粉了粉了！</p>
        <p @click="choose()">这个活动真不错，我来学习学习！</p>
        <p @click="choose()">已转发已点赞，好的品行要传扬！</p>
        <p @click="choose()">初到贵宝地，看到你们的活动，赞一个！</p>
        <p @click="choose()">咱们队友真是棒棒哒，下次继续一起活动哈！</p>
        <p @click="choose()">这个活动真不错，要继续推广下去！</p>
      </div>
    </van-popup>
    <!-- end -->
  </div>
</template>
<script>
import { ImagePreview } from "vant";
export default {
  name: "homepage",
  data() {
    return {
      name: "GOHOHO",
      activeNames: [],
      tab: 0,
      list: [],
      listorg: [],
      member: {},
      my_id: "",
      count: "",
      tx: "",
      listloading: false,
      listfinished: false,
      listpage: 1,
      listorgloading: false,
      listorgfinished: false,
      listorgpage: 1,
      isfollow: "",
      chooselist: "",
      chooselistindex: "",
      show: false,
      myname: "",
      editable: false,
      message: "",
      url: "//zhuzhan.ijiangyin.com/siteapp/appClient/sign",
      appId: "2312",
    };
  },
  created() {
    zjyapi.init({
      appId: this.appId,
      error: function (code, ret) {
        //失败回调,默认
        Toast("初始化失败");
      },
      success: function success(ret) {},
    });
    //我的信息
    this.$axios({
      method: "post",
      url: "/api/home/index",
    }).then((res) => {
      //console.log(res.data);
      this.my_id = res.data.data.member.id;
      this.myname = res.data.data.member.name;
      this.tx = res.data.data.member.img;
      if (res.data.data.member.img == "") {
        this.tx = "//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png";
      }
    });
    //个人主页内容
    this.inithomepage();
    //所属组织
    this.initorglist();
  },
  methods: {
    //to add 分享
    share(id, title, index, list, reportid) {
      this.openShare(title, id, index, list, reportid);
    },
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    openShare: function (title, id, index, list, reportid) {
      var that = this;
      this.getSign(function (sign) {
        zjyapi.openShare({
          sign: sign,
          params: {
            title: "江阴市新时代文明实践中心",
            content:
              "我在看大家参与" + title + "活动的图文及心得，你也快来看一看",
            url: "https://www.jywmsj.com/h5/#/topic?id=" + id, //分享地址
            imgUrl:
              "https://pic-cdn.bigdatajy.com/wenming/static/img/default.png", //分享图标地址
          },
          success: function (ret) {
            //console.log("分享成功：" + ret);
            var data = JSON.parse(ret);
            //console.log(ret);
            //console.log(data);
            that.zhuanfa(reportid, index, list);
          },
          error: function (error) {
            that.$toast("分享失败");
            //console.log("分享失败：" + JSON.stringify(error));
          },
        });
      });
    },
    //end
    showmorecomment(list, index) {
      list[index].commentnum += 1;
      this.$forceUpdate();
    },
    preview(imgs, index) {
      //console.log(imgs);
      ImagePreview({
        images: imgs,
        startPosition: index,
      });
    },
    edit() {
      if (this.editable) {
        //可编辑状态
        this.$axios({
          method: "post",
          url: "/api/report/editmyintro",
          data: this.qs.stringify({
            intro: this.message,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            this.inithomepage();
            this.editable = !this.editable;
          } else {
            this.$toast(res.data.msg);
          }
        });
      } else {
        this.editable = !this.editable;
      }
      this.$forceUpdate();
      //console.log(this.editable);
    },
    //add 点击头像进入个人主页
    tohomepage(id) {
      this.$router.push({
        name: "homepage",
        query: {
          id: id,
        },
      });
    },
    choosepinglun(list, index) {
      this.chooselist = list;
      this.chooselistindex = index;
      this.show = true;
    },
    choose() {
      //console.log(event.target.innerText);
      this.chooselist[this.chooselistindex].pinglun = event.target.innerText;
      this.show = false;
    },
    send(id, pinglun, list, index) {
      this.$axios({
        method: "post",
        url: "/api/report/comment",
        data: this.qs.stringify({
          report_id: id,
          content: pinglun,
        }),
      }).then((res) => {
        //console.log(res.data);
        if (res.data.code == 0) {
          this.$toast("操作成功");
          //console.log(list[index].pinglun);
          list[index].comments.unshift({
            content: list[index].pinglun,
            createtime: Date.parse(new Date()) / 1000,
            id: new Date().valueOf(),
            m_id: this.my_id,
            m_name: this.myname,
            headimg: this.tx,
          });
          list[index].pinglun = "";
          list[index].showcomment += 1;
          this.$forceUpdate();
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
    inithomepage() {
      this.listpage = 1;
      this.listfinished = false;
      this.listloading = false;
      this.list = [];
      this.$axios({
        method: "post",
        url: "/api/report/showlist",
        data: this.qs.stringify({
          m_id: this.$route.query.id,
        }),
      }).then((res) => {
        //console.log(res.data);
        this.isfollow = res.data.data.isfollow;
        this.member = res.data.data.member;
        this.message = this.member.intro;
        if (res.data.data.member.img == "") {
          this.member.img =
            "//pic-cdn.bigdatajy.com/wenming/static/img/icon3.png";
        }
        this.count = res.data.data.count;
        this.list = res.data.data.list;
        for (let i in this.list) {
          if (this.list[i].imgs != "") {
            this.list[i].imgs = this.list[i].imgs.split(",");
          }
          this.list[i].showcomment = 5;
          this.list[i].commentnum = 1;
          this.list[i].commentnummax = Math.ceil(
            (this.list[i].comments.length - this.list[i].showcomment) / 10
          );
        }
      });
    },
    initorglist() {
      this.listorgpage = 1;
      this.listorgfinished = false;
      this.listorgloading = false;
      this.listorg = [];
      this.$axios({
        method: "post",
        url: "/api/org/zy_list",
        data: this.qs.stringify({
          m_id: this.$route.query.id,
        }),
      }).then((res) => {
        //console.log(res.data);
        this.listorg = res.data.data.list;
      });
    },
    listload_more() {
      this.listpage += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/report/showlist",
            data: that.qs.stringify({
              page: that.listpage,
              m_id: that.$route.query.id,
            }),
          })
          .then((res) => {
            //console.log(res.data);
            if (res.data.code == 0) {
              if (res.data.data.list.length > 0) {
                for (let i in res.data.data.list) {
                  if (res.data.data.list[i].imgs != "") {
                    res.data.data.list[i].imgs =
                      res.data.data.list[i].imgs.split(",");
                  }
                  res.data.data.list[i].showcomment = 5;
                  res.data.data.list[i].commentnum = 1;
                  res.data.data.list[i].commentnummax = Math.ceil(
                    (res.data.data.list[i].comments.length -
                      res.data.data.list[i].showcomment) /
                      10
                  );
                }
              }
              that.list = that.list.concat(res.data.data.list);
            }
            that.listloading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.listfinished = true;
            } else {
              that.listfinished = false;
            }
          });
      }, 500);
    },
    listorgload_more() {
      this.listorgpage += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/org/zy_list",
            data: that.qs.stringify({
              page: that.listorgpage,
              m_id: that.$route.query.id,
            }),
          })
          .then((res) => {
            //console.log(res.data);
            if (res.data.code == 0) {
              that.listorg = that.listorg.concat(res.data.data.list);
            }
            that.listorgloading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.listorgfinished = true;
            } else {
              that.listorgfinished = false;
            }
          });
      }, 500);
    },
    totopic(id) {
      this.$router.push({
        name: "topic",
        query: {
          id: id,
        },
      });
    },
    urlchange(id) {
      this.$router.push({
        name: "orginazationdetail",
        query: {
          id: id,
        },
      });
    },
    //to add 转发
    zhuanfa(id, index, list) {
      this.$axios({
        method: "post",
        url: "/api/report/zhuanfa",
        data: this.qs.stringify({
          report_id: id,
        }),
      }).then((res) => {
        //console.log(res.data);
        list[index].zhuanfa += 1;
        /* if(res.data.code == 0){
          list[index].zhuanfa += 1;
          this.$toast('转发成功');
        }else{
          this.$toast(res.data.msg);
        } */
      });
    },
    //to add 点赞
    dianzan(id, index, list) {
      if (list[index].iszan == 1) {
        //取消
        this.$axios({
          method: "post",
          url: "/api/report/zan",
          data: this.qs.stringify({
            report_id: id,
            type: 2,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            list[index].iszan = null;
            list[index].zan -= 1;
          } else {
            this.$toast(res.data.msg);
          }
        });
      } else {
        //点赞
        this.$axios({
          method: "post",
          url: "/api/report/zan",
          data: this.qs.stringify({
            report_id: id,
            type: 1,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            list[index].iszan = 1;
            list[index].zan += 1;
          } else {
            this.$toast(res.data.msg);
          }
        });
      }
    },
    //to add 收藏
    shoucang(id, index, list) {
      if (list[index].isfav == 1) {
        //取消收藏
        this.$axios({
          method: "post",
          url: "/api/report/fav",
          data: this.qs.stringify({
            report_id: id,
            type: 2,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            list[index].isfav = null;
            list[index].fav -= 1;
          } else {
            this.$toast(res.data.msg);
          }
        });
      } else {
        //收藏
        this.$axios({
          method: "post",
          url: "/api/report/fav",
          data: this.qs.stringify({
            report_id: id,
            type: 1,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            list[index].isfav = 1;
            list[index].fav += 1;
          } else {
            this.$toast(res.data.msg);
          }
        });
      }
    },
    //to add 关注
    follow(id) {
      if (this.isfollow == 1) {
        //取消关注
        this.$axios({
          method: "post",
          url: "/api/report/follow",
          data: this.qs.stringify({
            member_id: id,
            type: 2,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            this.isfollow = null;
          } else {
            this.$toast(res.data.msg);
          }
        });
      } else {
        //关注
        this.$axios({
          method: "post",
          url: "/api/report/follow",
          data: this.qs.stringify({
            member_id: id,
            type: 1,
          }),
        }).then((res) => {
          //console.log(res.data);
          if (res.data.code == 0) {
            this.isfollow = 1;
          } else {
            this.$toast(res.data.msg);
          }
        });
      }
      this.$forceUpdate();
    },
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
  background: #f8f8f8;
}
img {
  width: 100%;
  display: block;
}
.top {
  background: #f8f8f8;
  border-radius: 15px 15px 0 0;
  display: flex;
  padding: 15px;
  margin-top: -30px;
  position: relative;
}
.tx {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
  margin-top: -36px;
}
.bt {
  margin-left: auto;
  /* border: 1px solid #bbbbbb; */
  padding: 2px 10px;
  height: fit-content;
  border-radius: 4px;
  color: white;
  background: #1646c0;
}
.name {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}
.tabs {
  width: 100%;
  margin: 0 auto;
  color: #999;
  background: #f8f8f8;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.tabs > div {
  width: 100%;
}
.tabs p {
  text-align: center;
  line-height: 36px;
  width: 100%;
}
.active {
  color: #333;
  font-weight: 500;
}
.maindiv {
  margin-top: 10px;
  background: white;
}
.main {
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
  background: white;
  margin-bottom: 10px;
}
.maintop {
  display: flex;
}
.maintop img {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 50%;
  display: block;
  margin-right: 10px;
}
.maintop .bt {
  margin-left: auto;
  align-self: center;
  border-radius: 5px;
  padding: 5px 10px;
  white-space: nowrap;
  color: #1646c0;
  font-size: 12px;
}
.pics {
  /* display: flex;
  flex-wrap: wrap; */
  height: 190px;
  width: 100%;
  margin-bottom: 10px;
}
.my-swipe {
  width: 100%;
  height: 190px;
}
.pics img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}
.date {
  color: #a1a1a1;
  font-size: 12px;
}
.tag {
  font-size: 12px;
}
.tag span {
  color: red;
}
.level {
  font-size: 12px;
}
.content {
  font-size: 14px;
  color: #333;
}
.content span {
  color: #5a7cab;
}
.txsmall {
  width: 10vw;
  height: 10vw;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 10px;
}
.flex {
  display: flex;
}
.el-textarea {
  width: 100%;
  outline: none;
  border: none;
  background: #f4f5f9;
  border-radius: 30px;
  line-height: 30px;
  font-size: 14px;
  min-height: 30px;
  text-indent: 10px;
}
.el-textarea /deep/ .el-textarea__inner {
  border-radius: 15px;
}
hr {
  margin: 10px 10px 0 10px;
}
.flexicon {
  display: flex;
  /*  justify-content: space-around; */
  align-items: center;
}
.flexicon > div {
  /* width: 100%; */
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #333;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.flexicon img {
  width: 18px;
  height: 18px;
  object-fit: contain;
}
/* .flexicon .van-icon {
  color: #cdcacb;
} */
.mainorg {
  padding: 10px 0;
  margin: 0 10px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  background: #f8f8f8;
  border-bottom: 1px solid #e5e5e5;
}
.mainorg img {
  width: 112px;
  height: 84px;
  object-fit: contain;
  margin-right: 10px;
  border-radius: 5px;
  flex-shrink: 0;
}
.right {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 12px;
}
.info {
  font-size: 14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: #666;
}
.location {
  font-size: 12px;
  color: cornflowerblue;
}
.mainorg .name {
  font-size: 16px;
  color: black;
  font-weight: 400;
}
.ygz {
  color: #999;
  background: #e5e5e5;
}
.red {
  color: red !important;
}
.state {
  margin: 10px auto;
  text-align: center;
}
.comments {
  padding: 15px;
}
.comments p {
  margin: 10px auto;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 10px;
}
.commentzoom {
  margin: 15px auto;
}
.flexcomment {
  display: flex;
}
.detail {
  padding: 16px;
}
.detail .flex {
  display: flex;
  justify-content: flex-start;
  margin: 10px 0;
}
.detail .flex p {
  color: #999;
  font-size: 12px;
  margin-right: 13px;
}
.detail .flex span {
  font-size: 16px;
  color: #333;
  font-weight: 600;
}
.tabhr {
  width: 2em;
  margin: auto;
  height: 3px;
  border-radius: 3px;
  background: #1646c0;
}
</style>


// WEBPACK FOOTER //
// src/components/homepage.vue